/**
 * @flow
 * @format
 */

import { branch, renderComponent, type HOC } from 'recompose';

import ErrorComponent from '~/components/ErrorComponent';

type P = {
  loading: boolean,
  hasError: boolean,
  currentStep: string,
};

const withErrorHandler: HOC<*, P> = branch(
  (props: P) => props.hasError,
  renderComponent(ErrorComponent),
);

export default withErrorHandler;



// WEBPACK FOOTER //
// ./src/hoc/withErrorHandler.js